<template>
  <Button @click.prevent="handleClick"
          class="button"
          :class="iconName">
  </Button>
</template>

<script>
  import { Component,  Prop, Vue } from 'vue-property-decorator'
  import Button from '@/components/common/Button'

  @Component({
    name: 'ButtonToggle',
    props: ['value'],
    components: {
      Button
    }
  })

  class ButtonToggle extends Vue {
    @Prop value

    handleClick() {
      this.$emit('input', !this.value)
    }

    get iconName() {
      return this.value ? this.$attrs.iconStateTrue :
        this.$attrs.iconStateFalse ;
    }
  }
  export default ButtonToggle
</script>

<style scoped lang="less">


</style>
